import { render, staticRenderFns } from "./AdminCustomerList.vue?vue&type=template&id=82b7025c&scoped=true&"
import script from "./AdminCustomerList.vue?vue&type=script&lang=ts&"
export * from "./AdminCustomerList.vue?vue&type=script&lang=ts&"
import style0 from "./AdminCustomerList.vue?vue&type=style&index=0&id=82b7025c&lang=scss&scoped=true&"
import style1 from "./AdminCustomerList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b7025c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VChip,VDataTable,VTextField})
